import { render, staticRenderFns } from "./NewsDet.vue?vue&type=template&id=1b7ab145&scoped=true"
import script from "./NewsDet.vue?vue&type=script&lang=js"
export * from "./NewsDet.vue?vue&type=script&lang=js"
import style0 from "./NewsDet.vue?vue&type=style&index=0&id=1b7ab145&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b7ab145",
  null
  
)

export default component.exports